
<div *ngIf="threatAssessmentSummary" class="h-full w-full flex flex-col items-center gap-4 pb-4 pr-2 overflow-y-auto">
    <div class="h-full w-full flex flex-col items-center gap-4 overflow-y-auto">
        <div *ngFor="let section of sections; let i = index;" class="w-full flex flex-col items-start text-start gap-1">
            <h2 class="w-full text-lg oswald-font">{{ i + 1}} - {{ section.sectionName }}</h2>
            <p *ngFor="let child of section.children" class="w-full text-gray-400">
                {{ child.questionText }} 
                <span *ngIf="child.type==='number'" class="text-gray-text">{{ showYesNo(this.threatAssessmentSummary[child.answer]) }}</span>
                <span *ngIf="child.type==='string'" class="text-gray-text">{{ this.threatAssessmentSummary[child.answer] }}</span>
                <span *ngIf="child.type==='date'" class="text-gray-text">{{ this.threatAssessmentSummary[child.answer] | date: 'MM/dd/yyyy' }}</span>
                <span *ngIf="child.type==='datetime'" class="text-gray-text">{{ this.threatAssessmentSummary[child.answer] | date: 'MM/dd/yyyy - HH:mm' }}</span>
            </p>
        </div>
    </div>
</div>


<div *ngIf="loading">
    <spinner></spinner>
</div>